module.exports = __webpack_public_path__ + "static/media/Tile Image - Sero WhiteGold.05313244.png";